import { useState, useEffect } from 'react';
import { ChangeItem, ChangeImpact, changeManagementService } from '../../services/change-management.service';


interface ChangeOrderFormProps {
  projectId: string;
  projectBudget: number;
  onSubmit: (data: any) => Promise<void>;
  onCancel: () => void;
  initialData?: any;
}

export function ChangeOrderForm({ projectId, projectBudget, onSubmit, onCancel, initialData }: ChangeOrderFormProps) {
  const [formData, setFormData] = useState({
    title: initialData?.title || '',
    description: initialData?.description || '',
    category: initialData?.category || 'other',
    priority: initialData?.priority || 'medium',
    items: initialData?.items || [{ description: '', quantity: 1, unit: 'm²', unitPrice: 0, total: 0, category: 'general', type: 'addition' as const }]
  });

  const [impact, setImpact] = useState<ChangeImpact | null>(null);
  const [isCalculating, setIsCalculating] = useState(false);

  const updateItem = (index: number, field: keyof ChangeItem, value: any) => {
    const newItems = [...formData.items];
    newItems[index] = { ...newItems[index], [field]: value };
    if (field === 'quantity' || field === 'unitPrice') {
      newItems[index].total = (newItems[index].quantity || 0) * (newItems[index].unitPrice || 0);
    }
    setFormData(prev => ({ ...prev, items: newItems }));
  };

  const addItem = () => {
    setFormData(prev => ({
      ...prev,
      items: [...prev.items, { description: '', quantity: 1, unit: 'm²', unitPrice: 0, total: 0, category: 'general', type: 'addition' as const }]
    }));
  };

  const removeItem = (index: number) => {
    if (formData.items.length > 1) {
      setFormData(prev => ({
        ...prev,
        items: prev.items.filter((_: ChangeItem, i: number) => i !== index)
      }));
    }
  };


  const calculateImpact = () => {
    setIsCalculating(true);
    const calculated = changeManagementService.calculateImpact(formData.items, projectBudget);
    setImpact(calculated);
    setIsCalculating(false);
  };

  useEffect(() => {
    if (formData.items.some((item: ChangeItem) => item.description && item.quantity > 0 && item.unitPrice > 0)) {
      calculateImpact();
    }
  }, [formData.items]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await onSubmit({
      ...formData,
      projectId,
      impact
    });
  };

  const getCategoryLabel = (category: string) => {
    const labels: Record<string, string> = {
      structural: 'Estructural',
      finishes: 'Acabados',
      systems: 'Sistemas',
      layout: 'Distribución',
      other: 'Otro'
    };
    return labels[category] || category;
  };

  const getPriorityLabel = (priority: string) => {
    const labels: Record<string, string> = {
      low: 'Baja',
      medium: 'Media',
      high: 'Alta',
      critical: 'Crítica'
    };
    return labels[priority] || priority;
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      {/* ... contenido del formulario ... */}
      <div className="space-y-3">
        {formData.items.map((item: ChangeItem, index: number) => (
          <div key={index} className="grid grid-cols-12 gap-2 items-center bg-gray-50 p-3 rounded-lg">
            {/* ... campos del item ... */}
          </div>
        ))}
      </div>
      {/* ... resto del formulario ... */}
    </form>
  );
}